import { takeEvery, delay } from 'redux-saga'
import { actionChannel, put, call, fork, flush, take } from 'redux-saga/effects'
import { updateCameraAction, batchUpdateCameraAction } from 'actions/cameraActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'
import { messageAction } from 'actions/messageActions'
import { UPDATE_CALCULATOR, BATCH_UPDATE_CALCULATOR } from 'actions/calculatorActionTypes'

export function * updateCalculator(action) {
  try {
    const { value, id, key, fromMap } = action
    if (value !== '') yield put.resolve(updateCameraAction(key, value, id))
    yield put(updatePresentationValuesAction(key, value, fromMap))
  } catch (err) {
    yield put(messageAction('generalError', err.message))
  }
}

export function * batchUpdateCalculator(action) {
  try {
    const { values, id, skipRoundFocal } = action
    const keys = Object.keys(values)
    yield put(batchUpdateCameraAction(keys, values, id))
    yield keys.map(k => put(updatePresentationValuesAction(k, values[k], true, skipRoundFocal)))
  } catch (err) {
    yield put(messageAction('generalError', err.message))
  }
}

function customBuffer() {
  let values = {}
  let action = {}

  const put = it => {
    action = it
    for (let v in it.values) {
      values[v] = it.values[v]
    }
  }

  const take = _ => action

  const flush = _ => {
    const items = values
    values = {}
    return items
  }

  return {
    isEmpty: () => Object.keys(values).length === 0,
    put,
    take,
    flush
  }
}

export function * watchBatchUpdateCalculator() {
  const batchChannel = yield actionChannel(BATCH_UPDATE_CALCULATOR, customBuffer())

  while (true) {
    const action = yield take(batchChannel)
    const values = yield flush(batchChannel)
    yield fork(batchUpdateCalculator, { id: action.id, values: { ...action.values, ...values }, skipRoundFocal: action.skipRoundFocal })
    yield call(delay, 500)
  }
}

export function * watchUpdateCalculator() {
  yield takeEvery(UPDATE_CALCULATOR, updateCalculator)
}



// WEBPACK FOOTER //
// ./src/sagas/updateCalculatorSagas.js